import React, { useState, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tooltip } from '@mui/material'
import { useTranslation } from "react-i18next"
import { M_Fieldset, BufferService, M_MessageBoard, M_InputTextField, LoadingContext, M_Button, M_Table } from 'src/M_Components'

const VoyageList = ({ roles, onCreateTab, toastMessages, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const [isLabel, setIsLabel] = useState(true)
    const [openElement, setOpenElement] = useState(false)
    const [valuesDict, setValuesDict] = useState(new Map())
    const navigate = useNavigate()
    const ctx = useContext(LoadingContext)
    const [refresh, setRefresh] = useState(false)
    const transportService = new BufferService('Transport/updateCutoff')
    const voyageService = new BufferService('Voyage')
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [voyageToDelete, setVoyageToDelete] = useState()


    const NewRoute = (url, label, operation = 'Create', data) => {
        sessionStorage.setItem('operation', operation)
        ctx.passValue.set('operation', operation)
        ctx.passValue.set('Row', data)
        navigate(`${url}`)
        onCreateTab(url, label)
    }

    const lineContextMenuVoyage = [
        { label: t('TimeLineCreatBook'), icon: 'pi pi-plus-circle', command: () => bufferContext("go/createBooking", "Create Booking") },
    ]

    const element = () => {
        return (
            <div style={{ margin: '10px', height: '90vh' }}>
                <iframe
                    title='pslnavegacao'
                    width="100%"
                    height="100%"
                    // src='https://pslnavegacao.com/en/?page_id=2303'
                    src='https://pslnavegacao.com/en/?page_id=2303'
                // srcDoc='https://pslnavegacao.com/en/?page_id=2303/'
                >

                </iframe>
            </div>
        )
    }

    const bufferContext = (url, label) => {
        let tempData = sessionStorage.getItem('context')
        if (tempData === 'undefined') {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        tempData = JSON.parse(tempData)

        sessionStorage.removeItem('context')
        sessionStorage.setItem('operation', 'Create')
        sessionStorage.setItem('bookingLine', JSON.stringify(tempData))
        NewRoute(url, label)
    }

    const bufferLine = (url, label) => {
        const temp = JSON.parse(sessionStorage.getItem('lines') || '[]')
        if (!temp.length) {
            toastMessages('error', '', t("SelectedLine"))
            return
        }
        const line = temp.pop()
        sessionStorage.removeItem('lines')
        sessionStorage.setItem('operation', 'Create')
        sessionStorage.setItem('bookingLine', JSON.stringify(line))
        NewRoute(url, label)
    }

    const onHide = (e) => {
        setIsLabel(e)
    }

    const removeContextItems = ['Create', 'Edit', 'Print']

    const getLineVoyage = (e) => {
        if (e.length) {
            sessionStorage.setItem('lines', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('lines')
        }
    }

    const getContextVoyage = (e) => {
        if (e) {
            sessionStorage.setItem('context', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('context')
        }
    }

    const closeElement = () => {
        valuesDict.set('Id', '')
        valuesDict.set('Vessel', '')
        valuesDict.set('VoyageNumber', '')
        valuesDict.set('Comments', '')
        valuesDict.set('CutOffDate', '')
        valuesDict.set('CutOffTime', '')
        valuesDict.set('ETA', '')
        setValuesDict(new Map(valuesDict))
        setOpenElement(false)
    }

    const openDrawer = () => {
        let tempLine = []
        if (!sessionStorage.getItem('lines')) {
            ctx.toastMessages('error', '', t("SelectedLine"))
            return
        }
        tempLine = JSON.parse(sessionStorage.getItem('lines'))[0]
        sessionStorage.removeItem('lines')
        valuesDict.set('Id', tempLine.Id)
        valuesDict.set('Vessel', tempLine.VesselCode)
        valuesDict.set('VoyageNumber', tempLine.VoyageNumber)
        valuesDict.set('Comments', tempLine.VoyageComments)
        valuesDict.set('ETA', tempLine.TransportExchange)


        valuesDict.set('CutOffDate', getDate(tempLine.TransportDate))
        valuesDict.set('CutOffTime', getTime(tempLine.TransportDate))

        setValuesDict(new Map(valuesDict))
        setOpenElement(true)
    }

    // function reformatDate(dateStr) {
    //     console.log(dateStr)
    //     var dArr = dateStr.split("-")  // ex input: "2010-01-18"
    //     return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) //ex output: "18/01/10"
    // }

    function getDate(dateStr) {
        const tempDate = dateStr.split(" ")[0]
        return tempDate

    }
    function getTime(dateStr) {
        const tempDate = dateStr.split(" ")[1]
        return tempDate
    }

    const getPermissions = () => {
        const tempButtons = []
        const tempPerm = []

        roles.forEach((role) => {
            if (role.match('voyages')) {
                tempPerm.push(role.split('voyages')[1])
            }
        })

        tempButtons.push({ label: t('LabelCheckSchedule'), element: <M_Button key={'VOYAGESBUTTON'} tooltip={t('LabelCheckSchedule')} label={t('LabelCheckSchedule')} icon={<img src='/icons/svgsDaNet/search.svg' alt='search' style={{ filter: 'invert(60%) sepia(93%) saturate(1397%) hue-rotate(169deg) brightness(83%) contrast(86%)', width: '20px' }} />} element={element()} /> })
        tempButtons.push({ label: t('TimeLineCreatBook'), element: 'default', source: '/icons/tableIcons/add.svg', style: {}, command: () => bufferLine("go/createBooking", "Create Booking") })
        if (roles.includes('transportsEdit')) tempButtons.push({ label: 'Edit CutOff', element: 'default', source: '/icons/tableIcons/edit.svg', command: () => openDrawer() })
        // if (tempPerm.includes('Create')) tempButtons.push({ label: t('CreateVoyage'), element: 'default', source: '/icons/tableIcons/add.svg', command: () => NewRoute('go/voyageDetail', t('CreateVoyage'), 'Create') })
        // if (tempPerm.includes('Edit')) tempButtons.push({ label: t('EditVoyage'), element: 'default', source: '/icons/tableIcons/edit.svg', command: (data) => NewRoute('go/voyageDetail', t('EditVoyage'), 'Edit', data) })
        if (tempPerm.includes('Delete')) tempButtons.push({ label: t('DeleteVoyage'), element: 'default', icon: <i className='pi pi-trash iconTable'></i>, command: (data) => { setOpenDeleteDialog(true); setVoyageToDelete(data); } })

        return tempButtons
    }

    const changeCutOffDate = (obj) => {
        console.log(obj.target.value)
        valuesDict.set("CutOffDate", obj.target.value)
        setValuesDict(new Map(valuesDict))
    }
    const changeCutOffTime = (obj) => {
        valuesDict.set("CutOffTime", obj.target.value)
        setValuesDict(new Map(valuesDict))
    }

    const submitCutOff = () => {
        ctx.setIsLoad(true)
        const tempDate = valuesDict.get('CutOffDate').concat(`T${valuesDict.get('CutOffTime')}`)
        const tempObj = {
            Id: valuesDict.get('Id'),
            cutoff: tempDate
        }


        transportService.update(tempObj.Id, tempObj).then(res => {
            ctx.setIsLoad(false)
            if (res.name === 'AxiosError') {
                toastMessages('error', res.message, '')
                return
            }
            valuesDict.set("CutOffDate", '')
            valuesDict.set("CutOffTime", '')
            setValuesDict(new Map(valuesDict))
            setOpenElement(false)
            setRefresh(true)
        })
    }

    const deleteVoyage = (data) => {
        const tempData = data
        ctx.passValue.set('lines', tempData)
        if (!tempData) {
            ctx.toastMessages('error', t("SelectedLine"), '')
            return
        }
        if (Array.isArray(tempData)) {
            ctx.passValue.delete('lines')
            deleteFunc(tempData[tempData.length - 1].VoyageId)
            return
        }
        deleteFunc(tempData.VoyageId)
    }

    function deleteFunc(id) {
        voyageService.delete(id).then(ResData => {
            if (ResData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t("ErrorVoyage"))
                return
            }
            ctx.toastMessages('success', '', t("SuccessVoyageDeleted"))
            setRefresh(true)
            setOpenDeleteDialog(false)
        })
    }

    return (
        <>
            <M_Table
                entityName={'voyage'}
                rolePermissions={roles}
                tablesOrder={tablesOrder}
                onTablesOrderUpdate={onTablesOrderUpdate}
                pageUrl={'Voyages'}
                lineContext={lineContextMenuVoyage}
                extraButtons={getPermissions()}
                removeContextItems={removeContextItems}
                onHideLabels={onHide}
                onPassLine={getLineVoyage}
                onPassContext={getContextVoyage}
                selectSingle={true}
                refresh={refresh}
                setRefresh={setRefresh}
                replaceFunctions={new Map([
                    ['View', (data) => NewRoute('go/voyageDetail', t('ViewVoyage'), 'View', data)]
                ])}
            />
            <M_MessageBoard
                open={openElement}
                minWidth={'30%'}
                onClose={closeElement}
                title={t('CuttOffTTitle')}
                body={
                    <M_Fieldset
                        labelInside
                        elements={
                            <span>
                                <span style={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: '10px' }}>
                                    <span className='spanItems'><b>{t("Vessel")}:</b> {valuesDict.get('Vessel')} </span>
                                    <span className='spanItems'><b>{t("Voyage")}:</b> {valuesDict.get('VoyageNumber')}  </span>
                                    <span className='spanItems'><b>{"Comments"}:</b> {valuesDict.get('Comments')} </span>
                                    <span className='spanItems'><b>{"ETA"}:</b> {valuesDict.get('ETA')} </span>
                                </span>
                                <br />
                                <div style={{ width: '100%', display: 'grid', gridTemplateColumns: 'auto auto', gridColumnGap: '20px' }}>
                                    <M_InputTextField type={'date'} label={'Cut-Off Date'} value={valuesDict.get('CutOffDate')} onChange={changeCutOffDate} />
                                    <M_InputTextField type={'time'} label={'Cut-Off Time'} value={valuesDict.get('CutOffTime')} onChange={changeCutOffTime} />
                                </div>
                            </span>
                        } />
                }
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={closeElement} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={submitCutOff} label={t("ButtonConfirm")} />
                    </span>
                }
            />
            <M_MessageBoard
                warning
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                title={`${t("Delete")} ${t("Voyage")}?`}
                body={<span>
                    {t("TitleConfirmDelete")} <b>{t("Voyage")}</b>
                </span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t("ButtonCancel")}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteDialog(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t("Delete")}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteVoyage(voyageToDelete)}
                        />
                    </div>
                }
            />
        </>
    )
}

export default VoyageList
